import { createSelector } from 'redux-bundler';

import {
  BOARD_DETAILS,
  ORGANIZATION_BOARDS,
  ORGANIZATION_DETAILS,
  ORGANIZATION_TEAM,
} from '../schema';

export const selectFreshOrganizationsKey = ({ fresh }) =>
  fresh?.organizations || {};
export const selectFreshUserKey = ({ fresh }) => fresh?.user || {};
export const selectFreshBoardsKey = ({ fresh }) => fresh?.boards || {};

export const selectFreshCurrentOrganization = createSelector(
  'selectFreshOrganizationsKey',
  'selectCurrentOrganizationId',
  (freshOrganizations, currentOrganizationId) =>
    freshOrganizations?.[currentOrganizationId] || {},
);

export const selectFreshCurrentBoard = createSelector(
  'selectFreshBoardsKey',
  'selectUrlParams',
  (freshBoardsKey, { boardId }) => freshBoardsKey?.[boardId] || {},
);

export const selectFreshCurrentOrganizationDetails = createSelector(
  'selectFreshCurrentOrganization',
  (freshCurrentOrganization) =>
    freshCurrentOrganization?.[ORGANIZATION_DETAILS] || false,
);

export const selectFreshCurrentOrganizationBoards = createSelector(
  'selectFreshCurrentOrganization',
  (freshCurrentOrganization) =>
    freshCurrentOrganization?.[ORGANIZATION_BOARDS] || false,
);

export const selectFreshCurrentOrganizationTeam = createSelector(
  'selectFreshCurrentOrganization',
  (freshCurrentOrganization) =>
    freshCurrentOrganization?.[ORGANIZATION_TEAM] || false,
);

export const selectFreshCurrentBoardDetails = createSelector(
  'selectFreshCurrentBoard',
  (freshCurrentBoard) => freshCurrentBoard?.[BOARD_DETAILS] || false,
);
